import { render, staticRenderFns } from "./FormDescription.vue?vue&type=template&id=3de3ae4d&scoped=true"
import script from "./FormDescription.vue?vue&type=script&lang=js"
export * from "./FormDescription.vue?vue&type=script&lang=js"
import style0 from "./FormDescription.vue?vue&type=style&index=0&id=3de3ae4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de3ae4d",
  null
  
)

export default component.exports